import { axios } from "../http/axios.js";
import { api } from '../../constants/api.js';

function replaceParams(url, type, id) {
    return url
        .replace(":type", type)
        .replace(":id", id);
}

const engagementService = {
    async createProduct(formData) {
        const response = await axios.post(api.products.create, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    },

    async updateProduct(type, id, formData) {
        const endpoint = replaceParams(api.products.update, type, id);
        const response = await axios.put(endpoint, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    },

    async createCheckoutSession(data) {
        // if your route is /api/engagement/checkout-session:
        const response = await axios.post(api.products.createEngagementSession, data);
        return response.data;
    },

    async verifyEngagementPayment(sessionId) {
        try {
            const response = await axios.get(api.store.verifyEngagementPayment(sessionId));
            return response.data;
        } catch (error) {
            console.error('Error verifying tip payment:', error);
            throw error;
        }
    },

    // 2) Save buyer’s details
    async saveBuyerDetails(details) {
        const response = await axios.post(api.store.saveBuyerDetails, details);
        return response.data;
    },

    async fetchUnfulfilledOrders() {
        try {
            const response = await axios.get(api.engagement.fetchUnfulfilled);
            return response.data;
        } catch (error) {
            console.error('Error fetching unfulfilled engagement orders:', error);
            throw error;
        }
    },

    async fetchFulfilledOrders() {
        try {
            const response = await axios.get(api.engagement.fetchFulfilled);
            return response.data;
        } catch (error) {
            console.error('Error fetching fulfilled engagement orders:', error);
            throw error;
        }
    },

    async updateEngagementFulfillment(orderId, data) {
        try {
            const response = await axios.post(
                api.engagement.updateFulfillment(orderId),
                data
            );
            return response.data;
        } catch (error) {
            console.error('Error updating engagement fulfillment:', error);
            throw error;
        }
    },

    async getEngagementDetails(orderId) {
        try {
            const response = await axios.get(api.engagement.getDetails(orderId));
            return response.data;
        } catch (error) {
            console.error('Error fetching engagement details:', error);
            throw error;
        }
    },
};

export default engagementService;
